import React from 'react'
import ProductListComponent from '../../components/products/ProductListComponent'

const ProductListPage = () => {
  return (
    <>
    <div className='mb-5'>ProductListPage</div>
    <ProductListComponent />
    </>
  )
}

export default ProductListPage